import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const accordionBoxComponentStyles: SxStyles = {
  accordionBoxComponent: {
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
    alignItems: 'end',
    width: '100%',
    p: 0,
    '& .title-container': {
      display: 'flex',
      justifyContent: 'center',
      pl: getResponsiveSize(10),
      width: getResponsiveSize(120),
      '& .title': {
        display: 'flex',
        fontFamily: theme.typography.mainFontFamily,
        fontWeight: '400',
        color: theme.palette.mainControls?.subTitleColor,
        fontSize: theme.typography.fs13,
        textAlign: 'center',
        p: 0,
        pb: getResponsiveSize(10),
        pointerEvents: 'none',
      },
    },
  },
};
